import React from 'react';
export function Privacy() {
  return <div className="max-w-3xl mx-auto px-6 pt-32 pb-24" data-id="element-10699" data-mp="lkqlmuwh2pqz">
      <h1 className="text-4xl font-bold text-[#2B211A] mb-8 font-title tracking-tight" data-id="element-10700" data-mp="2wk6z5qsa29fr">
        Privacy Policy
      </h1>

      <div className="space-y-8 text-neutral-600 font-body leading-relaxed" data-id="element-10701" data-mp="3b9ml8tgv5qp4">
        <section data-id="element-10702" data-mp="36hbb6xsesoiu">
          <p className="text-lg text-neutral-700" data-id="element-10703" data-mp="36gtgw6pb4kdk">
            This Privacy Policy explains how Giga collects, uses, discloses, and
            safeguards your information when you visit our website or use our
            service (the &quot;Service&quot;), and describes your privacy rights and
            how the law protects you. By using the Service, you agree to the
            collection and use of information in accordance with this Policy.
          </p>
        </section>

        <section data-id="element-10704" data-mp="1zswf1acfwyvi">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-10705" data-mp="1zufw335x7dyc">
            1. Who We Are &amp; Key Definitions
          </h2>
          <p className="mb-4" data-id="element-10706" data-mp="h25ydt7gar37">
            Giga is operated by <strong data-id="element-10707" data-mp="h3qv9ph8mm48">Tonic Labs Limited</strong>, a company
            registered in Ireland (&quot;Giga&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;). For the
            purposes of the EU General Data Protection Regulation (GDPR) and the
            UK GDPR, Tonic Labs Limited is the <strong data-id="element-10708" data-mp="uuchno5whe6v">Data Controller</strong> of
            personal data processed through the Service. You can contact us about
            privacy at{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-10709" data-mp="14rqnyuy40mlg">
              support@getgiga.com
            </a>
            .
          </p>
          <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-10710" data-mp="18riy3c35j0sx">
            <li data-id="element-10711" data-mp="1dr5axkf2if17">
              <strong data-id="element-10712" data-mp="1drnfr5fsq1kq">Personal Data</strong> — any information relating to an
              identified or identifiable individual.
            </li>
            <li data-id="element-10713" data-mp="3fjjns52r8tar">
              <strong data-id="element-10714" data-mp="3fj08yx8eil0y">Usage Data</strong> — data collected automatically from
              your use of the Service (e.g. IP address, browser type, pages
              visited, timestamps).
            </li>
            <li data-id="element-10715" data-mp="hr9xaojwicl6">
              <strong data-id="element-10716" data-mp="hrt3j806vcjd">Connected-Service Data</strong> — data we access from a
              third-party service you connect (e.g. Google Workspace, Slack) on
              your instruction, solely to carry out your requests.
            </li>
            <li data-id="element-10717" data-mp="15o790gdjei8d">
              <strong data-id="element-10718" data-mp="15nnoqt0ezhr6">Service Provider / Processor</strong> — a third party that
              processes data on our behalf under contract.
            </li>
          </ul>
        </section>

        <section data-id="element-10719" data-mp="1eghg3ot4y7le">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-10720" data-mp="1eh0syr3xi5sk">
            2. Information We Collect
          </h2>
          <p className="mb-4" data-id="element-10721" data-mp="1afp62tcfvyo2">
            <strong data-id="element-10722" data-mp="1oef5wgqn8cg4">Information you provide.</strong> When you create an account,
            connect integrations, or communicate with us, we collect information
            such as your name, email address, workspace configuration, and any
            content you submit through the Service.
          </p>
          <p className="mb-4" data-id="element-10723" data-mp="28071vemt7niv">
            <strong data-id="element-10724" data-mp="27z5nb06l4iwe">Information collected automatically.</strong> When you use the
            Service we automatically collect Usage Data, including your IP
            address, device and browser type, the pages you visit, and the time
            and duration of your visit.
          </p>
          <p className="mb-4" data-id="element-10725" data-mp="1k9utk2nnjorr">
            <strong data-id="element-10726" data-mp="1k9l36dyp3flj">Connected-Service Data.</strong> When you connect a
            third-party integration (including Google Workspace, Gmail, Google
            Drive, Google Docs, Google Calendar, and Slack), we access and process
            data from those services <em data-id="element-10727" data-mp="1fb02yejg0vx3">only</em> to fulfil the specific requests
            you make and to provide the Service&apos;s functionality. See Section 5
            for exactly what Google data we access and why.
          </p>
        </section>

        <section data-id="element-10728" data-mp="15d3opdv7lkur">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-10729" data-mp="15fq1pt0vcskd">
            3. Cookies, Analytics &amp; Tracking
          </h2>
          <p className="mb-4" data-id="element-10730" data-mp="tcdmzashw1nl">
            Our website uses cookies and similar technologies to operate the site
            and understand how it is used. These website analytics are entirely
            separate from — and never draw on — the Google user data described in
            Section 5. We use:
          </p>
          <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-10731" data-mp="fl8rmkw5tvj2">
            <li data-id="element-10732" data-mp="akb8a4zeyvfz">
              <strong data-id="element-10733" data-mp="ajt8wzhgg13u">Google Analytics</strong> — to measure website traffic and
              usage patterns.
            </li>
            <li data-id="element-10734" data-mp="5lzzzyoroszv">
              <strong data-id="element-10735" data-mp="5nkujob30bxq">PostHog</strong> — for product analytics, to understand how
              features are used and improve them.
            </li>
            <li data-id="element-10736" data-mp="1zypuoimym68b">
              <strong data-id="element-10737" data-mp="1zz91p4b2na7k">Reditus</strong> — to attribute referrals from our affiliate
              programme.
            </li>
          </ul>
          <p className="mb-4" data-id="element-10738" data-mp="1uyv127bsv2jk">
            Cookies may be &quot;session&quot; cookies (deleted when you close your browser)
            or &quot;persistent&quot; cookies (which remain until they expire or you delete
            them). You can instruct your browser to refuse cookies or alert you
            when one is set; some parts of the Service may not function properly
            without them. Where required by law, we ask for your consent before
            setting non-essential cookies. We honour recognised browser-based
            opt-out signals (including Global Privacy Control) where applicable.
          </p>
        </section>

        <section data-id="element-10739" data-mp="1tihehuacinmy">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-10740" data-mp="1thxvea8ylt7c">
            4. How We Use Your Information &amp; Legal Bases
          </h2>
          <p className="mb-4" data-id="element-10741" data-mp="34xmg0uyqqg4z">
            We use your information to provide, maintain, secure, and improve the
            Service; to carry out the actions you request; to manage your account;
            to communicate with you about the Service; and to comply with our
            legal obligations. Under the GDPR, we rely on the following legal
            bases:
          </p>
          <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-10742" data-mp="2u8cf3ktmkwwe">
            <li data-id="element-10743" data-mp="2u5q75k2tofdn">
              <strong data-id="element-10744" data-mp="2p8q1vbdsrgnl">Performance of a contract</strong> — to provide the Service
              and carry out the tasks you ask Giga to perform.
            </li>
            <li data-id="element-10745" data-mp="21jn9b8hmk3eb">
              <strong data-id="element-10746" data-mp="21h161l1roa1w">Legitimate interests</strong> — to secure, maintain, and
              improve the Service and understand how it is used, balanced against
              your rights.
            </li>
            <li data-id="element-10747" data-mp="2bb1e9vschveu">
              <strong data-id="element-10748" data-mp="26i89x90sgp3a">Consent</strong> — for non-essential cookies and optional
              communications, which you may withdraw at any time.
            </li>
            <li data-id="element-10749" data-mp="1iqt6fcxa01qg">
              <strong data-id="element-10750" data-mp="1iqjhlsnyw0mc">Legal obligation</strong> — where we must process data to
              comply with the law.
            </li>
          </ul>
        </section>

        <section data-id="element-10751" data-mp="3pg4mn0rgvrzt">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-10752" data-mp="3pflegbrmchyz">
            5. Google User Data &amp; Limited Use
          </h2>
          <p className="mb-4" data-id="element-10753" data-mp="3fji3qhipbb0f">
            Giga&apos;s use of information received from Google APIs will adhere to
            the{' '}
            <a href="https://developers.google.com/terms/api-services-user-data-policy" className="text-[#EA580C] hover:underline font-medium" target="_blank" rel="noopener noreferrer" data-id="element-10754" data-mp="3ki34ci1v7wpe">
              Google API Services User Data Policy
            </a>
            , including the Limited Use requirements.
          </p>
          <p className="mb-4" data-id="element-10755" data-mp="33o6uchpne9o">
            We request the narrowest scopes needed to provide the features you
            ask for. Specifically:
          </p>
          <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-10756" data-mp="2nqrfat79eqlq">
            <li data-id="element-10757" data-mp="2rsw6zme5dd5q">
              <strong data-id="element-10758" data-mp="2rtebt7evkzp9">Gmail (<code data-id="element-10759" data-mp="2ru779c8dw2s3">gmail.modify</code>)</strong> — read the content
              and labels of messages you point Giga to, and, on your instruction,
              compose, send, draft, label, archive, and organise mail. We do not
              request permanent-deletion or full-account scopes.
            </li>
            <li data-id="element-10760" data-mp="3agu30ewjx85d">
              <strong data-id="element-10761" data-mp="3agaprbhuj7xo">Google Drive (<code data-id="element-10762" data-mp="35gxuq3gtmuk0">drive</code>)</strong> — find, read,
              create, edit, move, and share files you ask Giga to act on,
              including files you did not create, so Giga can act on your existing
              content by description.
            </li>
            <li data-id="element-10763" data-mp="20r0enkaq9nw">
              <strong data-id="element-10764" data-mp="22bwihm9e0nv">Google Docs (<code data-id="element-10765" data-mp="3tewrmsl6t32n">documents</code>)</strong> — read and edit
              the body content of documents you ask Giga to work on (insert,
              rewrite, restructure, or summarise sections in place).
            </li>
            <li data-id="element-10766" data-mp="pq1vppivnbun">
              <strong data-id="element-10767" data-mp="pqlfzcw02cbu">Google Calendar (<code data-id="element-10768" data-mp="pr4mzyk43gb3">calendar.events</code>)</strong> — read
              your schedule and create, update, or cancel individual events on
              your instruction. We do not request broader calendar-settings
              scopes.
            </li>
          </ul>
          <p className="mb-4" data-id="element-10769" data-mp="xadu1l55b2wz">
            Google user data is accessed only when you ask Giga to act on it, used
            solely to compose the response or perform the action you requested,
            and not retained afterwards. We do <strong data-id="element-10770" data-mp="16bc3wk29m4nh">not</strong> use Google user
            data for advertising or targeting, and we do <strong data-id="element-10771" data-mp="1b8kjccw13ul1">not</strong> use
            it to develop, improve, or train generalised AI/ML models. Any transfer
            to a third party is limited to what is necessary to provide the Service
            at your direction (see Section 6) or as required by law.
          </p>
        </section>

        <section data-id="element-10772" data-mp="1px6yadhqukbq">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-10773" data-mp="1pzt52awt8vsw">
            6. How We Share Your Information &amp; Subprocessors
          </h2>
          <p className="mb-4" data-id="element-10774" data-mp="1yyy4rkk3yv6n">
            We do <strong data-id="element-10775" data-mp="1ria96ctrurht">not</strong> sell your personal data. We share it only
            with service providers who process it on our behalf under contract, and
            only as needed to run the Service:
          </p>
          <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-10776" data-mp="21fognmxpw5xz">
            <li data-id="element-10777" data-mp="21e4z7t0broum">
              <strong data-id="element-10778" data-mp="266y1894esj30">AI model provider — Anthropic, PBC.</strong> To carry out
              your requests, relevant content may be sent as ephemeral context to
              Anthropic&apos;s Claude models. Under Anthropic&apos;s commercial API
              terms, this data is <strong data-id="element-10779" data-mp="2f5rubpij6rbt">not used to train their models</strong>
              and is not retained beyond what is needed to return the response.
            </li>
            <li data-id="element-10780" data-mp="2p628bcce42s1">
              <strong data-id="element-10781" data-mp="2p4hczki94ft4">Cloud hosting &amp; infrastructure — Hetzner (EU).</strong>{' '}
              Hosts the application and database within the EU.
            </li>
            <li data-id="element-10782" data-mp="urhp743pwfar">
              <strong data-id="element-10783" data-mp="uqzo9u641cwi">Backup storage — Cloudflare R2 (EU).</strong> Encrypted
              database backups are stored in EU-based object storage.
            </li>
            <li data-id="element-10784" data-mp="33bcaiunnyqmm">
              <strong data-id="element-10785" data-mp="33bkkoesejhu4">Analytics providers</strong> — Google Analytics, PostHog, and
              Reditus, for website and product analytics only (never Google user
              data).
            </li>
          </ul>
          <p className="mb-4" data-id="element-10786" data-mp="2ubfh6fqbx3l8">
            We may also disclose data in connection with a merger, acquisition, or
            asset sale (with notice), or as described in Section 10.
          </p>
        </section>

        <section data-id="element-10787" data-mp="3n0mpg6fl57jo">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-10788" data-mp="3n036cme78d42">
            7. Data Security &amp; AI Processing
          </h2>
          <p className="mb-4" data-id="element-10789" data-mp="3d1x6sbfv7j2d">
            We implement appropriate technical and organisational security
            measures designed to protect your information, including encryption at
            rest and in transit. No method of transmission or storage is 100%
            secure, but we work to protect your data using commercially acceptable
            means.
          </p>
          <p className="mb-4" data-id="element-10790" data-mp="281ywqru5ao5i">
            Giga uses a vault-proxy architecture for all third-party integrations.
            When you connect a service (e.g. Gmail, Google Drive, Slack), your
            credentials — API keys, OAuth tokens, and other secrets — are stored
            encrypted in a dedicated vault and are never exposed to our AI models
            or placed into model context. All authenticated requests are proxied
            through the vault, which injects the credential server-side so the raw
            secret never reaches the application layer.
          </p>
          <p className="mb-4" data-id="element-10791" data-mp="1fdjmeilyku0i">
            When you ask Giga to act on connected data (e.g. summarise an email,
            find a file), the relevant content may be passed as ephemeral context
            to an LLM solely to fulfil your request. This processing is transient:
            context is not stored after the response is generated, and we do not
            train foundational AI models on your private data, chat history, or
            connected-service content. Your data remains yours.
          </p>
        </section>

        <section data-id="element-10792" data-mp="wqaprd74vd7z">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-10793" data-mp="wquaf1o64fpp">
            8. Data Retention &amp; Deletion
          </h2>
          <p className="mb-4" data-id="element-10794" data-mp="15pnz85v9c1sp">
            We retain your data for as long as your account is active or as needed
            to provide the Service. When you disconnect an integration, we stop
            accessing that data. When you delete your account, we delete or
            anonymise your data within 30 days, unless we are required by law to
            retain it. To request deletion at any time, contact{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-10795" data-mp="1ohguy81po144">
              support@getgiga.com
            </a>
            .
          </p>
        </section>

        <section data-id="element-10796" data-mp="3dwj7ajnxnolq">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-10797" data-mp="3dx1ay1cxd53o">
            9. International Data Transfers
          </h2>
          <p className="mb-4" data-id="element-10798" data-mp="3nnm4399txhf7">
            We are based in Ireland (EU). Some of our service providers (including
            Anthropic) are located outside the European Economic Area, so your data
            may be transferred to and processed in countries whose data-protection
            laws differ from your own. Where we transfer personal data outside the
            EEA or UK, we rely on appropriate safeguards such as the European
            Commission&apos;s Standard Contractual Clauses or an adequacy decision.
          </p>
        </section>

        <section data-id="element-10799" data-mp="38zsss0rs112f">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-10800" data-mp="38w4z91mc0enp">
            10. Your Privacy Rights (GDPR &amp; UK GDPR)
          </h2>
          <p className="mb-4" data-id="element-10801" data-mp="o6nxaghr3y67">
            If you are in the EEA or UK, you have the right to access, rectify,
            erase, restrict, or object to the processing of your personal data; the
            right to data portability; and the right to withdraw consent at any
            time. To exercise any of these rights, contact{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-10802" data-mp="1uywcds85bmjt">
              support@getgiga.com
            </a>
            .
          </p>
          <p className="mb-4" data-id="element-10803" data-mp="1pxfd215b885c">
            You also have the right to lodge a complaint with a supervisory
            authority. Our lead authority is the Irish{' '}
            <a href="https://www.dataprotection.ie" className="text-[#EA580C] hover:underline font-medium" target="_blank" rel="noopener noreferrer" data-id="element-10804" data-mp="1gzwrmvnr7rsx">
              Data Protection Commission
            </a>
            , though you may also contact the authority in your own country.
          </p>
        </section>

        <section data-id="element-10805" data-mp="36etbuadm1ova">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-10806" data-mp="36c786ltubtic">
            11. Your Privacy Rights (California / CCPA)
          </h2>
          <p className="mb-4" data-id="element-10807" data-mp="3uay3t71c9ug2">
            If you are a California resident, you have the right to know what
            personal information we collect and how it is used; to request
            deletion or correction of your personal information; and to
            non-discrimination for exercising these rights. We do{' '}
            <strong data-id="element-10808" data-mp="czf6yxkf2esh">not</strong> sell your personal information, and we do not share
            it for cross-context behavioural advertising. To make a request,
            contact{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-10809" data-mp="32twvxtjidhs">
              support@getgiga.com
            </a>
            .
          </p>
        </section>

        <section data-id="element-10810" data-mp="2nvdyi90qbw72">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-10811" data-mp="2sse4yl1hr0yp">
            12. Legal Disclosures
          </h2>
          <p className="mb-4" data-id="element-10812" data-mp="2l7tu4yn0i6lp">
            We may disclose your personal data if we believe in good faith that it
            is necessary to comply with a legal obligation, respond to valid
            requests by public authorities (such as a court or government agency),
            protect the rights, property, or safety of Giga, our users, or the
            public, or investigate possible wrongdoing in connection with the
            Service.
          </p>
        </section>

        <section data-id="element-10813" data-mp="1xk3hanxh0wwg">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-10814" data-mp="1xklmia242lgi">
            13. Children&apos;s Privacy
          </h2>
          <p className="mb-4" data-id="element-10815" data-mp="26jyxx89spk3v">
            The Service is not directed to children under 16, and we do not
            knowingly collect personal data from them. If you believe a child has
            provided us personal data, contact us and we will delete it.
          </p>
        </section>

        <section data-id="element-10816" data-mp="1dtgug655tgpx">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-10817" data-mp="t9rf13qsie4h">
            14. Changes to This Policy
          </h2>
          <p className="mb-4" data-id="element-10818" data-mp="xbl6qmj0c7si">
            We may update this Privacy Policy from time to time. We will notify you
            of any material changes by email or through the Service.
          </p>
        </section>

        <section data-id="element-10819" data-mp="17766ee0lsvz3">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-10820" data-mp="1c8bz4bu9kj8m">
            15. Contact Us
          </h2>
          <p data-id="element-10821" data-mp="1g8vxfiqkpswc">
            If you have questions or comments about this Privacy Policy, or wish to
            exercise your rights, contact us at{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-10822" data-mp="1l307iav4yh1n">
              support@getgiga.com
            </a>
            {' '}or by post to Tonic Labs Limited, Ireland.
          </p>
        </section>

        <section className="pt-8 border-t border-neutral-200/60" data-id="element-10823" data-mp="1zyzk9yt6x5d4">
          <p className="text-sm text-neutral-500" data-id="element-10824" data-mp="3kfpau7bxlmjl">Last updated: July 2026</p>
          <p className="text-sm text-neutral-500 mt-1" data-id="element-10825" data-mp="3kdm9ws98q903">
            © 2026 Tonic Labs Limited. All rights reserved.
          </p>
        </section>
      </div>
    </div>;
}